// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.ZoomAndFocus in videoConfig/zoomConfiguration.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Float
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Zoom and focus configuration
 *
 * @property zoom zoom position
 * @property focus focus position
 * @property zoom_mini zoom range minimum
 * @property zoom_max zoom range maximum
 * @property focus_mini focus range minimum
 * @property focus_max focus range maximum
 */
public class ZoomAndFocus(
  /**
   * Zoom and focus position set as percentage
   */
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val zoom: Float = 0f,
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 1,
  )
  public val focus: Float = 0f,
  /**
   * Zoom and focus range
   */
  @field:WireField(
    tag = 3,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "zoomMini",
    schemaIndex = 2,
  )
  public val zoom_mini: Float = 0f,
  @field:WireField(
    tag = 4,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "zoomMax",
    schemaIndex = 3,
  )
  public val zoom_max: Float = 0f,
  @field:WireField(
    tag = 5,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "focusMini",
    schemaIndex = 4,
  )
  public val focus_mini: Float = 0f,
  @field:WireField(
    tag = 6,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "focusMax",
    schemaIndex = 5,
  )
  public val focus_max: Float = 0f,
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<ZoomAndFocus, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is ZoomAndFocus) return false
    if (unknownFields != other.unknownFields) return false
    if (zoom != other.zoom) return false
    if (focus != other.focus) return false
    if (zoom_mini != other.zoom_mini) return false
    if (zoom_max != other.zoom_max) return false
    if (focus_mini != other.focus_mini) return false
    if (focus_max != other.focus_max) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + zoom.hashCode()
      result = result * 37 + focus.hashCode()
      result = result * 37 + zoom_mini.hashCode()
      result = result * 37 + zoom_max.hashCode()
      result = result * 37 + focus_mini.hashCode()
      result = result * 37 + focus_max.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """zoom=$zoom"""
    result += """focus=$focus"""
    result += """zoom_mini=$zoom_mini"""
    result += """zoom_max=$zoom_max"""
    result += """focus_mini=$focus_mini"""
    result += """focus_max=$focus_max"""
    return result.joinToString(prefix = "ZoomAndFocus{", separator = ", ", postfix = "}")
  }

  public fun copy(
    zoom: Float = this.zoom,
    focus: Float = this.focus,
    zoom_mini: Float = this.zoom_mini,
    zoom_max: Float = this.zoom_max,
    focus_mini: Float = this.focus_mini,
    focus_max: Float = this.focus_max,
    unknownFields: ByteString = this.unknownFields,
  ): ZoomAndFocus = ZoomAndFocus(zoom, focus, zoom_mini, zoom_max, focus_mini, focus_max, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<ZoomAndFocus> = object : ProtoAdapter<ZoomAndFocus>(
      FieldEncoding.LENGTH_DELIMITED, 
      ZoomAndFocus::class, 
      "type.googleapis.com/vreo.volt.protocol.ZoomAndFocus", 
      PROTO_3, 
      null, 
      "videoConfig/zoomConfiguration.proto"
    ) {
      override fun encodedSize(`value`: ZoomAndFocus): Int {
        var size = value.unknownFields.size
        if (!value.zoom.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(1, value.zoom)
        }
        if (!value.focus.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(2, value.focus)
        }
        if (!value.zoom_mini.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(3, value.zoom_mini)
        }
        if (!value.zoom_max.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(4, value.zoom_max)
        }
        if (!value.focus_mini.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(5, value.focus_mini)
        }
        if (!value.focus_max.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(6, value.focus_max)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: ZoomAndFocus) {
        if (!value.zoom.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 1, value.zoom)
        }
        if (!value.focus.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 2, value.focus)
        }
        if (!value.zoom_mini.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 3, value.zoom_mini)
        }
        if (!value.zoom_max.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 4, value.zoom_max)
        }
        if (!value.focus_mini.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 5, value.focus_mini)
        }
        if (!value.focus_max.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 6, value.focus_max)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: ZoomAndFocus) {
        writer.writeBytes(value.unknownFields)
        if (!value.focus_max.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 6, value.focus_max)
        }
        if (!value.focus_mini.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 5, value.focus_mini)
        }
        if (!value.zoom_max.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 4, value.zoom_max)
        }
        if (!value.zoom_mini.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 3, value.zoom_mini)
        }
        if (!value.focus.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 2, value.focus)
        }
        if (!value.zoom.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 1, value.zoom)
        }
      }

      override fun decode(reader: ProtoReader): ZoomAndFocus {
        var zoom: Float = 0f
        var focus: Float = 0f
        var zoom_mini: Float = 0f
        var zoom_max: Float = 0f
        var focus_mini: Float = 0f
        var focus_max: Float = 0f
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> zoom = ProtoAdapter.FLOAT.decode(reader)
            2 -> focus = ProtoAdapter.FLOAT.decode(reader)
            3 -> zoom_mini = ProtoAdapter.FLOAT.decode(reader)
            4 -> zoom_max = ProtoAdapter.FLOAT.decode(reader)
            5 -> focus_mini = ProtoAdapter.FLOAT.decode(reader)
            6 -> focus_max = ProtoAdapter.FLOAT.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return ZoomAndFocus(
          zoom = zoom,
          focus = focus,
          zoom_mini = zoom_mini,
          zoom_max = zoom_max,
          focus_mini = focus_mini,
          focus_max = focus_max,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: ZoomAndFocus): ZoomAndFocus = value.copy(
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
